export class UserAuthorizationViewModel {
    moduleId: number;
}



